import React from "react";

import "./e-paper-button.m.css";
import { Link } from "@quintype/components";

const EPaperButton = () => {
  return (
    <button styleName="wrapper">
      <Link href="https://epaper.deccanherald.com/" target="_blank">
        E-PAPER
      </Link>
    </button>
  );
};

export default EPaperButton;
